/**
 * Role-Based Content Utilities
 */

import type { UserRole } from '@/types/roles';

/**
 * Get default filter based on user role
 */
export function getDefaultFilter(userRole: UserRole, userId: string): string {
  switch (userRole) {
    case 'credit-controller':
      return userId;          // Show MY work only
      
    case 'team-leader':
    case 'manager':
      return 'everyone';      // Show TEAM work
      
    case 'fp-a':
    case 'finance-director':
      return 'everyone';      // Show COMPANY-WIDE work
      
    default:
      return userId;
  }
}

/**
 * Get default tab based on user role
 */
export function getDefaultTab(userRole: UserRole): string {
  // All roles start with overview for now
  return 'overview';
}

/**
 * Check if a section should be visible for a given role
 */
export function shouldShowSection(
  sectionName: string,
  userRole: UserRole
): boolean {
  const sectionRoles: Record<string, UserRole[]> = {
    'todaysPriorities': ['credit-controller', 'team-leader', 'manager'],
    'leaderboard': ['team-leader', 'manager', 'fp-a', 'finance-director'],
    'strategicInsights': ['fp-a', 'finance-director'],
    'auditTrails': ['fp-a', 'finance-director'],
    'teamCoordination': ['team-leader', 'manager'],
    'editStrategies': ['team-leader', 'manager']
  };
  
  return sectionRoles[sectionName]?.includes(userRole) ?? true;
}
